const LOCAL_API = false;

export const JWT_KEY = 'FeSDJJ5FZwEnCN6fx8LCMAcsle2MqYJeGwa';
export const EXPIRATION_TIME = `${1000 * 60 * 60 * 4}ms`;

export const API_ROUTE = LOCAL_API ?
    'http://localhost:5001/kba-4c/us-central1/api' :
    'https://us-central1-kba-4c.cloudfunctions.net/api';
